import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b550f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "checkout-close-button" }

import { DialogTitle } from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/24/solid';

interface CheckoutHeaderProps {
  onClose: () => void;
  success: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutHeaderForPledge',
  props: {
    onClose: { type: Function },
    success: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const close = () => {
  props.onClose();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_unref(DialogTitle), { class: "checkout-title" }, {
      default: _withCtx(() => [
        (props.success)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Order successful"))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "Contribute"))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        onClick: close
      }, [
        _createVNode(_unref(XMarkIcon))
      ])
    ])
  ]))
}
}

})